var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCartOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H3.33333L3.6 3.33333M3.6 3.33333H14L11.3333 8.66667H4.66667M3.6 3.33333L4.66667 8.66667M4.66667 8.66667L3.138 10.1953C2.718 10.6153 3.01533 11.3333 3.60933 11.3333H11.3333M11.3333 11.3333C10.9797 11.3333 10.6406 11.4738 10.3905 11.7239C10.1405 11.9739 10 12.313 10 12.6667C10 13.0203 10.1405 13.3594 10.3905 13.6095C10.6406 13.8595 10.9797 14 11.3333 14C11.687 14 12.0261 13.8595 12.2761 13.6095C12.5262 13.3594 12.6667 13.0203 12.6667 12.6667C12.6667 12.313 12.5262 11.9739 12.2761 11.7239C12.0261 11.4738 11.687 11.3333 11.3333 11.3333ZM6 12.6667C6 13.0203 5.85952 13.3594 5.60948 13.6095C5.35943 13.8595 5.02029 14 4.66667 14C4.31304 14 3.97391 13.8595 3.72386 13.6095C3.47381 13.3594 3.33333 13.0203 3.33333 12.6667C3.33333 12.313 3.47381 11.9739 3.72386 11.7239C3.97391 11.4738 4.31304 11.3333 4.66667 11.3333C5.02029 11.3333 5.35943 11.4738 5.60948 11.7239C5.85952 11.9739 6 12.313 6 12.6667Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCartOutline);
export default __webpack_public_path__ + "static/media/ShoppingCartOutline.330efa9a2bec67f1aeb0f39539c72044.svg";
export { ForwardRef as ReactComponent };